import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useDebugValue, useEffect, useMemo, useState, useRef } from 'react';
import DateUtils from '../../utils/date';
var useValueToDate = function useValueToDate(utils, _ref) {
  var value = _ref.value,
    initialFocusedDate = _ref.initialFocusedDate;
  var nowRef = useRef(utils.date());
  var date = utils.date(value || initialFocusedDate || nowRef.current);
  return date && utils.isValid(date) ? date : nowRef.current;
};
function useDateValues(props, options) {
  var utils = new DateUtils();
  var date = useValueToDate(utils, props);
  var format = props.format || options.getDefaultFormat();
  return {
    date: date,
    format: format
  };
}
export function useCalendarState(props, options) {
  var _onChange = props.onChange;
  var utils = new DateUtils();
  var _useDateValues = useDateValues(props, options),
    date = _useDateValues.date;
  var _useState = useState(date),
    _useState2 = _slicedToArray(_useState, 2),
    calendarDate = _useState2[0],
    setCalendarDate = _useState2[1];
  useEffect(function () {
    // if value was changed in closed state - treat it as accepted
    if (!utils.isEqual(calendarDate, date)) {
      setCalendarDate(date);
    }
  }, [date, calendarDate, utils]);
  var calendarProps = useMemo(function () {
    return {
      date: calendarDate,
      onChange: function onChange(newDate) {
        var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        setCalendarDate(newDate);
        if (isFinish) {
          _onChange(newDate);
        }
      }
    };
  }, [_onChange, calendarDate]);
  var calendarState = {
    calendarProps: calendarProps
  };
  useDebugValue(calendarState);
  return calendarState;
}